import React, { useEffect } from 'react';
import Select from 'react-select';
import { Funnel } from '../../../types/funnels';

type EnsureDescricao<T extends { descricao?: string }> = Omit<T, 'descricao'> & { descricao: string };

interface FunnelSelectorProps {
    funnels: EnsureDescricao<Funnel>[];
    selectedFunnel: EnsureDescricao<Funnel> | null;
    onFunnelChange: (funnel: Funnel | null) => void;
    loading: boolean;
}

const FunnelSelector: React.FC<FunnelSelectorProps> = ({
    funnels,
    selectedFunnel,
    onFunnelChange,
    loading
}) => {
    // Estilos customizados para o Select
    const customStyles = {
        // Container do select
        container: (provided: any) => ({
            ...provided,
            width: '300px', // Ajuste a largura aqui
        }),
        // Área de controle (onde fica o valor selecionado)
        control: (provided: any) => ({
            ...provided,
            minHeight: '40px', // Altura do select
            fontSize: '16px', // Tamanho da fonte
            
        }),
        // Opção selecionada
        singleValue: (provided: any) => ({
            ...provided,
            fontSize: '16px', // Tamanho da fonte do valor selecionado
            color: '#333', // Cor do texto selecionado
        }),
        // Menu dropdown
        menu: (provided: any) => ({
            ...provided,
            fontSize: '16px', // Tamanho da fonte do menu
        }),
        // Opções no dropdown
        option: (provided: any, state: any) => ({
            ...provided,
            fontSize: '16px', // Tamanho da fonte das opções
            backgroundColor: state.isSelected ? '#00918E' : state.isFocused ? '#f0f0f0' : null,
            color: state.isSelected ? 'white' : '#333',
            padding: '8px 12px', // Padding interno das opções
        }),
        // Placeholder
        placeholder: (provided: any) => ({
            ...provided,
            fontSize: '16px', // Tamanho da fonte do placeholder
            color: '#E6F4F4', // Cor do placeholder
        }),
    };

    const funnelOptions = funnels.map(funnel => ({
        value: funnel.id,
        label: funnel.nome,
        data: funnel
    }));

    const selectedOption = selectedFunnel ? {
        value: selectedFunnel.id,
        label: selectedFunnel.nome,
        data: selectedFunnel
    } : null;

    return (
        <div className="d-flex align-items-center">
            <div className="">
                <div className="mb-3">
                    <Select
                        name="funnel"
                        className="select2"
                        options={funnelOptions}
                        value={selectedOption}
                        onChange={(option: any) => {
                            if (option) {
                                onFunnelChange(option.data);
                            } else {
                                onFunnelChange(null);
                            }
                        }}
                        placeholder="Selecione o funil"
                        classNamePrefix="react-select"
                        isLoading={loading}
                        noOptionsMessage={() => "Nenhum funil encontrado"}
                        loadingMessage={() => "Carregando..."}
                        styles={customStyles}
                    />
                </div>
            </div>
            <h4 className="page-title">
                <span className="count-title">{selectedFunnel?.total_etapas || 0} Etapas</span>
            </h4>
        </div>
    );
};

export default FunnelSelector;